import React from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Grid,
  Box,
} from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import img1 from "../assets/home1.jpg";
import img2 from "../assets/home1.jpg";
import img3 from "../assets/home1.jpg";
import img4 from "../assets/home1.jpg";
import "../styles/Pages.css";

const PageTwo = () => {
  const navigate = useNavigate();

  const cards = [
    { title: "Residential", img: img1, link: "/page2/sub5" },
    { title: "Villas", img: img2, link: "/page2/sub6" },
    { title: "Commercial", img: img3, link: "/page2/sub7" },
    { title: "Apartments", img: img4, link: "/page2/sub8" },
  ];

  return (
    <Box className="page2-container">
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Typography variant="h4" className="page2-title">
          Material Contract Works
        </Typography>
      </motion.div>

      <Grid container spacing={4} justifyContent="center" className="page-grid">
        {cards.map((card, i) => (
          <Grid item key={i} xs={12} sm={6} md={3}>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.3 }}
              whileHover={{ scale: 1.05 }}
            >
              <Card
                className="page2-card"
                onClick={() => navigate(card.link)}
                style={{ cursor: "pointer" }}
              >
                <CardMedia component="img" height="160" image={card.img} />
                <CardContent>
                  <Typography variant="h6" className="page2-card-title">
                    {card.title}
                  </Typography>
                </CardContent>
              </Card>
            </motion.div>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PageTwo;
